import React from 'react'
import { Link, NavLink } from 'react-router-dom'

export const menuItems = [
  { name: 'Home', path: '/' },
  { name: 'Portfolio', path: '/portfolio' },
  { name: 'Products', path: '/products' },
  { name: 'Services', path: '/services' },
  { name: 'Contact', path: '/contact' }
]
export function Header () {
  return (
    <header className='site-header'>
      <Link className='wordmark' to='/' aria-label='Chris Cassano home'>CHRIS CASSANO<span className='wordmark-dot' aria-hidden='true'>↗</span></Link>
      <nav aria-label='Main navigation'>
        {menuItems.map(item => <NavLink key={item.path} exact={item.path === '/'} to={item.path} activeClassName='is-active' isActive={item.name === 'Portfolio' ? (_, location) => /^\/(portfolio|projects|galleries|a)(\/|$)/.test(location.pathname) : undefined}>{item.name}</NavLink>)}
      </nav>
    </header>
  )
}
